export interface ProviderItem {
  slug: string;
  name: string;
}

export const providerData: ProviderItem[] = [
  { slug: 'moonpay', name: 'MoonPay' },
  { slug: 'onramper', name: 'Onramper' },
  { slug: 'mercuryo', name: 'Mercuryo' },
  { slug: 'simplex', name: 'Simplex' },
  { slug: 'transak', name: 'Transak' },
  { slug: 'banxa', name: 'Banxa' },
  { slug: 'ramp', name: 'Ramp' },
  { slug: 'alchemy', name: 'Alchemy Pay' },
  { slug: 'charlie', name: 'Charlie' },
];

export const providerSectionTranslations = {
  title: {
    en: 'More ways to buy cryptocurrencies',
    es: 'Más formas de comprar criptomonedas',
    ru: 'Больше способов купить криптовалюту',
    zh: '更多购买加密货币的方式',
  },
  subtitle: {
    en: 'Explore additional options to buy crypto assets quickly and securely',
    es: 'Explora opciones adicionales para comprar criptomonedas de forma rápida y segura',
    ru: 'Изучите дополнительные варианты, чтобы быстро и безопасно купить криптоактивы',
    zh: '探索其他可快速且安全购买加密资产的选项',
  },
  linkPrefix: {
    en: 'Buy Crypto with',
    es: 'Comprar criptomonedas con',
    ru: 'Купить криптовалюту с',
    zh: '通过...购买加密货币',
  },
};

export const getProviderUrl = (slug: string, locale: string): string =>
  locale === 'en' ? `/${slug}/` : `/${locale}/${slug}/`;
